/**
 * Client-side data export helpers.
 * - exportCsv: writes a UTF-8 CSV (Excel-compatible via BOM prefix).
 * - printView: opens a print-optimized window for PDF export via browser dialog.
 */

function csvEscape(v) {
  if (v === null || v === undefined) return "";
  const s = String(v);
  if (/[",\n\r;]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}

export function exportCsv(filename, columns, rows) {
  const header = columns.map((c) => csvEscape(c.label)).join(";");
  const body = rows
    .map((r) => columns.map((c) => csvEscape(typeof c.value === "function" ? c.value(r) : r[c.key])).join(";"))
    .join("\n");
  // UTF-8 BOM makes Excel open Turkish characters correctly.
  const blob = new Blob(["\ufeff" + header + "\n" + body], {
    type: "text/csv;charset=utf-8;",
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename.endsWith(".csv") ? filename : `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export function printView(title, columns, rows) {
  const w = window.open("", "_blank", "width=1024,height=800");
  if (!w) return;
  const styles = `
    <style>
      body{font-family:Georgia,serif;color:#1B2A5C;padding:24px}
      h1{font-size:22px;margin:0 0 8px}
      .meta{color:#64748B;font-size:12px;margin-bottom:20px}
      table{width:100%;border-collapse:collapse;font-size:12px}
      th,td{padding:8px 10px;border-bottom:1px solid #E2E8F0;text-align:left}
      th{background:#F1F5F9;text-transform:uppercase;font-size:10px;letter-spacing:0.05em}
      tfoot td{font-weight:600;border-top:2px solid #1B2A5C}
      @media print{ button{display:none} }
    </style>`;
  const head = columns.map((c) => `<th>${c.label}</th>`).join("");
  const body = rows
    .map(
      (r) =>
        "<tr>" +
        columns
          .map(
            (c) =>
              `<td>${(typeof c.value === "function" ? c.value(r) : r[c.key]) ?? ""}</td>`
          )
          .join("") +
        "</tr>"
    )
    .join("");
  w.document.write(`
    <!doctype html><html><head><title>${title}</title>${styles}</head>
    <body>
      <h1>${title}</h1>
      <div class="meta">Ariaf ASIS Acente Paneli · ${new Date().toLocaleString("tr-TR")}</div>
      <table><thead><tr>${head}</tr></thead><tbody>${body}</tbody></table>
      <script>window.onload=()=>setTimeout(()=>window.print(),300)</script>
    </body></html>
  `);
  w.document.close();
}
